import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-714e4c2b"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "card",
  style: {"margin-bottom":"15px","margin-top":"-25px"}
}
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, "Manual Orders", -1))
const _hoisted_4 = { class: "card-toolbar" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "btn btn-icon btn-outline-default h-35px w-35px btn-outline",
  style: {"border-radius":"50%","margin-left":"10px"}
}, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "currentColor",
    class: "bi bi-download",
    viewBox: "0 0 16 16"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" }),
    /*#__PURE__*/_createElementVNode("path", { d: "M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z" })
  ])
], -1))
const _hoisted_6 = { class: "card-body" }
const _hoisted_7 = { style: {"float":"left"} }
const _hoisted_8 = { style: {"float":"right","color":"var(--el-text-color-secondary)","font-size":"13px"} }
const _hoisted_9 = { style: {"float":"left"} }
const _hoisted_10 = { style: {"float":"right","color":"var(--el-text-color-secondary)","font-size":"13px"} }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Reset")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Search ")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("+ Increase")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("- Decrease")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Transfer")
const _hoisted_16 = { style: {"margin-left":"10px"} }
const _hoisted_17 = /*#__PURE__*/_createTextVNode("Comment: ")
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { style: {"color":"#222831"} }
const _hoisted_21 = { style: {"color":"#3F72AF"} }
const _hoisted_22 = { style: {"color":"#00ADB5"} }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { style: {"color":"#222831"} }
const _hoisted_26 = { style: {"color":"#3F72AF"} }
const _hoisted_27 = { style: {"color":"#00ADB5"} }
const _hoisted_28 = { key: 1 }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { key: 1 }
const _hoisted_31 = { key: 2 }
const _hoisted_32 = /*#__PURE__*/_createTextVNode("Completed ")
const _hoisted_33 = /*#__PURE__*/_createTextVNode("Rejected ")
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "Logo",
  src: "media/icons/lp/tick.png",
  class: "h-25px"
}, null, -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"gray"} }, [
  /*#__PURE__*/_createTextVNode("Input amount "),
  /*#__PURE__*/_createElementVNode("strong", null, "or"),
  /*#__PURE__*/_createTextVNode(" conversion rate")
], -1))
const _hoisted_36 = { style: {"color":"#165DFF"} }
const _hoisted_37 = /*#__PURE__*/_createTextVNode("Amount")
const _hoisted_38 = /*#__PURE__*/_createTextVNode("Conversion Rate")
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Comment", -1))
const _hoisted_40 = ["onUpdate:modelValue"]
const _hoisted_41 = { style: {"float":"right"} }
const _hoisted_42 = /*#__PURE__*/_createTextVNode("Confirm")
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"float":"right","margin-right":"10px"} }, null, -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "Logo",
  src: "media/icons/lp/cancel.png",
  class: "h-25px"
}, null, -1))
const _hoisted_45 = /*#__PURE__*/_createTextVNode(" You will reject this exchange order and this action can not be undo. ")
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Comment", -1))
const _hoisted_47 = ["onUpdate:modelValue"]
const _hoisted_48 = { style: {"float":"right"} }
const _hoisted_49 = /*#__PURE__*/_createTextVNode("Reject")
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"float":"right","margin-right":"10px"} }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_radio_group, {
            modelValue: _ctx.selectedType,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedType) = $event)),
            size: "small"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_radio_button, {
                label: "All",
                onClick: _ctx.refreshAllList
              }, null, 8, ["onClick"]),
              _createVNode(_component_el_radio_button, {
                label: "Increase",
                onClick: _ctx.refreshIncreaseList
              }, null, 8, ["onClick"]),
              _createVNode(_component_el_radio_button, {
                label: "Decrease",
                onClick: _ctx.refreshDecreaseList
              }, null, 8, ["onClick"]),
              _createVNode(_component_el_radio_button, {
                label: "Transfer",
                onClick: _ctx.refreshTransferList
              }, null, 8, ["onClick"])
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _hoisted_5
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_el_form, {
          inline: true,
          model: _ctx.formInline,
          class: "demo-form-inline",
          size: "small",
          "label-position": 'right',
          "label-width": "auto",
          ref: "searchForm"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "From Account",
              prop: "accountFromId"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.formInline.accountFromId,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formInline.accountFromId) = $event)),
                  placeholder: "please select an account",
                  style: {"width":"100%"},
                  filterable: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accountsRef, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item,
                        label: item.source.name +'_'+item.accountName +'_'+item.accountNumber + ' '+ item.currency,
                        value: item.id
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", _hoisted_7, _toDisplayString(item.source.name +'_'+item.accountName +'_'+item.accountNumber), 1),
                          _createElementVNode("span", _hoisted_8, _toDisplayString(item.currency), 1)
                        ]),
                        _: 2
                      }, 1032, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "To Account",
              prop: "accountToId"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.formInline.accountToId,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formInline.accountToId) = $event)),
                  placeholder: "please select an account",
                  style: {"width":"100%"},
                  filterable: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accountsRef, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item,
                        label: item.source.name +'_'+item.accountName +'_'+item.accountNumber + ' '+ item.currency,
                        value: item.id
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", _hoisted_9, _toDisplayString(item.source.name +'_'+item.accountName +'_'+item.accountNumber), 1),
                          _createElementVNode("span", _hoisted_10, _toDisplayString(item.currency), 1)
                        ]),
                        _: 2
                      }, 1032, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"]),
        _createVNode(_component_el_button, {
          onClick: _ctx.resetFormFields,
          icon: _ctx.Search,
          size: "small",
          style: {"float":"right"}
        }, {
          default: _withCtx(() => [
            _hoisted_11
          ]),
          _: 1
        }, 8, ["onClick", "icon"]),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _ctx.onSubmitSearchForm,
          icon: _ctx.Search,
          size: "small",
          style: {"float":"right","margin-right":"10px"}
        }, {
          default: _withCtx(() => [
            _hoisted_12
          ]),
          _: 1
        }, 8, ["onClick", "icon"])
      ])
    ]),
    _createVNode(_component_router_link, { to: { name: 'manualOrdersDetail', params: { id: 'increase'}} }, {
      default: _withCtx(() => [
        _createVNode(_component_el_button, {
          type: "primary",
          size: "small",
          style: {"margin-bottom":"10px","margin-right":"15px"}
        }, {
          default: _withCtx(() => [
            _hoisted_13
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_router_link, { to: { name: 'manualOrdersDetail', params: { id: 'decrease'}} }, {
      default: _withCtx(() => [
        _createVNode(_component_el_button, {
          type: "primary",
          size: "small",
          style: {"margin-bottom":"10px","margin-right":"15px"}
        }, {
          default: _withCtx(() => [
            _hoisted_14
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_router_link, { to: { name: 'manualOrdersDetail', params: { id: 'transfer'}} }, {
      default: _withCtx(() => [
        _createVNode(_component_el_button, {
          type: "primary",
          size: "small",
          style: {"margin-bottom":"10px"}
        }, {
          default: _withCtx(() => [
            _hoisted_15
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      data: _ctx.manualOrdersRef,
      style: {"width":"100%"},
      height: "550",
      size: "default"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          type: "expand",
          fixed: "",
          width: "20"
        }, {
          default: _withCtx((account) => [
            _createElementVNode("p", _hoisted_16, [
              _hoisted_17,
              _hoisted_18,
              _createTextVNode(_toDisplayString(account.row.remarks), 1)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          fixed: "",
          prop: "id",
          label: "ID",
          width: "60"
        }),
        _createVNode(_component_el_table_column, {
          prop: "type",
          label: "Operation Type",
          width: "140"
        }),
        _createVNode(_component_el_table_column, {
          prop: "orderType",
          label: "Type",
          width: "140"
        }),
        _createVNode(_component_el_table_column, {
          prop: "tag",
          label: "Tag",
          width: "140"
        }),
        _createVNode(_component_el_table_column, {
          prop: "accountFrom",
          label: "From account",
          width: "350"
        }, {
          default: _withCtx((account) => [
            (account.row.accountFrom)
              ? (_openBlock(), _createElementBlock("span", _hoisted_19, [
                  _createElementVNode("span", _hoisted_20, _toDisplayString(account.row.accountFrom.source.name+ '_'), 1),
                  _createElementVNode("span", _hoisted_21, _toDisplayString(account.row.accountFrom.accountName+ '_'), 1),
                  _createElementVNode("span", _hoisted_22, _toDisplayString(account.row.accountFrom.accountNumber), 1)
                ]))
              : (_openBlock(), _createElementBlock("span", _hoisted_23, " - "))
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "accountTo",
          label: "To account",
          width: "350"
        }, {
          default: _withCtx((account) => [
            (account.row.accountTo)
              ? (_openBlock(), _createElementBlock("span", _hoisted_24, [
                  _createElementVNode("span", _hoisted_25, _toDisplayString(account.row.accountTo.source.name+ '_'), 1),
                  _createElementVNode("span", _hoisted_26, _toDisplayString(account.row.accountTo.accountName+ '_'), 1),
                  _createElementVNode("span", _hoisted_27, _toDisplayString(account.row.accountTo.accountNumber), 1)
                ]))
              : (_openBlock(), _createElementBlock("span", _hoisted_28, " - "))
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "balanceType",
          label: "Balance From-To",
          width: "185"
        }, {
          default: _withCtx((account) => [
            (account.row.balanceTypeFrom && account.row.balanceTypeTo)
              ? (_openBlock(), _createElementBlock("div", _hoisted_29, _toDisplayString((account.row.balanceTypeFrom ? account.row.balanceTypeFrom : '')) + "->" + _toDisplayString((account.row.balanceTypeTo ?account.row.balanceTypeTo :'')), 1))
              : _createCommentVNode("", true),
            (account.row.balanceTypeFrom && !account.row.balanceTypeTo)
              ? (_openBlock(), _createElementBlock("div", _hoisted_30, _toDisplayString((account.row.balanceTypeFrom ? account.row.balanceTypeFrom : '')), 1))
              : _createCommentVNode("", true),
            (!account.row.balanceTypeFrom && account.row.balanceTypeTo)
              ? (_openBlock(), _createElementBlock("div", _hoisted_31, _toDisplayString((account.row.balanceTypeTo ?account.row.balanceTypeTo :'')), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "amountFrom",
          label: "Amount",
          width: "120"
        }, {
          default: _withCtx((account) => [
            _createTextVNode(_toDisplayString(account.row.type === 'Increase' ? account.row.amountTo : (account.row.orderType === 'Decrease'? account.row.amountFrom :  (account.row.accountFrom ? account.row.amountFrom :account.row.amountTo ))), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "currencyFrom",
          label: "Currency",
          width: "120"
        }, {
          default: _withCtx((account) => [
            _createTextVNode(_toDisplayString(account.row.type === 'Increase' ? account.row.currencyTo : (account.row.orderType === 'Decrease'? account.row.currencyFrom : (account.row.accountFrom ? account.row.currencyFrom :account.row.currencyTo ))), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "conversionRate.rate",
          label: "Conversion Rate",
          width: "140"
        }, {
          default: _withCtx((account) => [
            _createTextVNode(_toDisplayString(account.row.conversionRate ? account.row.conversionRate.currency +' ' + account.row.conversionRate.rate:'-'), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "createdAt",
          label: "Created At",
          width: "250"
        }, {
          default: _withCtx((account) => [
            _createTextVNode(_toDisplayString(_ctx.DateTimeUtils.parseDateTime(account.row.createdAt)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "updatedAt",
          label: "Updated At",
          width: "250"
        }, {
          default: _withCtx((account) => [
            _createTextVNode(_toDisplayString(_ctx.DateTimeUtils.parseDateTime(account.row.updatedAt)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "operatedBy.name",
          label: "Registered User",
          width: "140"
        }),
        _createVNode(_component_el_table_column, {
          prop: "approvedBy.name",
          label: "ApprovedUser",
          width: "130"
        }),
        _createVNode(_component_el_table_column, {
          fixed: "right",
          label: "Action",
          width: "120"
        }, {
          default: _withCtx((record) => [
            (record.row.status === 'Completed')
              ? (_openBlock(), _createBlock(_component_el_tag, {
                  key: 0,
                  class: "ml-2",
                  type: "success",
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    _hoisted_32
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (record.row.status === 'Failed')
              ? (_openBlock(), _createBlock(_component_el_tag, {
                  key: 1,
                  class: "ml-2",
                  type: "danger",
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    _hoisted_33
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (record.row.status === 'Created')
              ? (_openBlock(), _createBlock(_component_el_popover, {
                  key: 2,
                  placement: "left",
                  title: "Approve Confirmation",
                  width: 400,
                  trigger: "click"
                }, {
                  reference: _withCtx(() => [
                    _hoisted_34
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_el_row, null, {
                      default: _withCtx(() => [
                        _hoisted_35
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_row, { style: {"margin-top":"10px"} }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.inputAmount,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.inputAmount) = $event)),
                          placeholder: "Please input the amount",
                          size: "small",
                          onInput: ($event: any) => (_ctx.blurAmount(record.row))
                        }, {
                          append: _withCtx(() => [
                            _createElementVNode("span", _hoisted_36, _toDisplayString(record.row.accountTo.currency), 1)
                          ]),
                          prepend: _withCtx(() => [
                            _hoisted_37
                          ]),
                          _: 2
                        }, 1032, ["modelValue", "onInput"])
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_el_row, { style: {"margin-top":"10px","margin-bottom":"10px"} }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.inputRate,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.inputRate) = $event)),
                          placeholder: "Please input the rate",
                          size: "small",
                          onInput: ($event: any) => (_ctx.blurRate(record.row))
                        }, {
                          prepend: _withCtx(() => [
                            _hoisted_38
                          ]),
                          _: 2
                        }, 1032, ["modelValue", "onInput"])
                      ]),
                      _: 2
                    }, 1024),
                    _hoisted_39,
                    _createVNode(_component_el_row, { style: {"margin-top":"5px"} }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("textarea", {
                          rows: 2,
                          type: "textarea",
                          style: {"width":"100%"},
                          placeholder: "Please input",
                          class: "el-textarea__inner",
                          "onUpdate:modelValue": ($event: any) => ((record.row.remarks) = $event)
                        }, "\r\n            ", 8, _hoisted_40), [
                          [
                            _vModelText,
                            record.row.remarks,
                            void 0,
                            { lazy: true }
                          ]
                        ])
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_el_row, { style: {"margin-top":"10px"} }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_col, { span: 24 }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_41, [
                              _createVNode(_component_el_button, {
                                type: "success",
                                size: "small",
                                onClick: ($event: any) => (_ctx.popUpConfirm(record))
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_42
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ]),
                            _hoisted_43
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true),
            (record.row.status === 'Created')
              ? (_openBlock(), _createBlock(_component_el_popover, {
                  key: 3,
                  placement: "left",
                  title: "Please confirm!",
                  width: 300,
                  trigger: "click"
                }, {
                  reference: _withCtx(() => [
                    _hoisted_44
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", null, [
                      _createVNode(_component_el_row, { style: {"margin-bottom":"10px"} }, {
                        default: _withCtx(() => [
                          _hoisted_45
                        ]),
                        _: 1
                      }),
                      _hoisted_46,
                      _createVNode(_component_el_row, { style: {"margin-top":"5px","margin-bottom":"10px"} }, {
                        default: _withCtx(() => [
                          _withDirectives(_createElementVNode("textarea", {
                            rows: 2,
                            type: "textarea",
                            style: {"width":"100%"},
                            placeholder: "Please input",
                            class: "el-textarea__inner",
                            "onUpdate:modelValue": ($event: any) => ((record.row.remarks) = $event)
                          }, "\r\n            ", 8, _hoisted_47), [
                            [
                              _vModelText,
                              record.row.remarks,
                              void 0,
                              { lazy: true }
                            ]
                          ])
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_el_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, { span: 24 }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_48, [
                                _createVNode(_component_el_button, {
                                  type: "danger",
                                  size: "small",
                                  onClick: ($event: any) => (_ctx.popUpCancel(record))
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_49
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"])
                              ]),
                              _hoisted_50
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024)
                    ])
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"])), [
      [_directive_loading, _ctx.loadingRef]
    ]),
    _createVNode(_component_el_pagination, {
      currentPage: _ctx.pageNumberRef,
      "onUpdate:currentPage": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.pageNumberRef) = $event)),
      "page-size": _ctx.pageSizeRef,
      small: _ctx.small,
      "page-sizes": [20, 30, 40, 50],
      layout: "total,sizes, prev, pager, next",
      total: _ctx.totalRef,
      style: {"float":"right"},
      onSizeChange: _ctx.updatePageSize,
      onCurrentChange: _ctx.updatePageNumber
    }, null, 8, ["currentPage", "page-size", "small", "total", "onSizeChange", "onCurrentChange"])
  ], 64))
}